import { ChatbotIcon } from "../../shared/icons";
import "./chatbot-button.scss";

export const ChatbotButton = ({ chatbot: { key, openChatText, overrideImage } }) => (
    <>
        <button id="bring-chatbot-button" data-bot-key={key} aria-label={openChatText}>
            {overrideImage ? (
                <img
                    src={overrideImage}
                    alt={openChatText}
                    style={{ maxWidth: "70%", maxHeight: "70%" }}
                />
            ) : (
                <ChatbotIcon />
            )}
        </button>
    </>
);
